import { ErrorService } from '../../../core/services/error.service';
import { LocationService } from '../../location/services/location.service';
import { GroupSeriesDto } from '../dtos/group-series.dto';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GroupSerieService } from '../services/group-serie.service';
import { LocationSummaryDto } from '../../location/dtos/location-summary.dto';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTable, MatTableModule } from '@angular/material/table';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ReorderDto } from '../../../shared/dtos/reorder.dto';
import { ManageGroupSeriesDialog } from '../dialogs/manage-group-series/manage-group-series.dialog';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';
import { MatMenuModule } from '@angular/material/menu';
import { MemoryService } from '../../../core/services/memory.service';

@Component({
  selector: 'app-group-serie',
  imports: [MatMenuModule, MatCardModule, MatFormFieldModule, ReactiveFormsModule, MatSelectModule, MatTableModule, CdkDrag, CdkDropList, MatIconModule, MatButtonModule, DatePipe, TranslocoPipe],
  templateUrl: './group-series.component.html',
  styleUrl: './group-series.component.scss'
})
export class GroupSeriesComponent implements OnInit {
  @ViewChild('table') table!: MatTable<any>;
  locationSummaryDtos!: LocationSummaryDto[];
  locationFormControl!: FormControl;

  groupSeriesDtos!: GroupSeriesDto[];

  constructor(private memoryService: MemoryService,private groupSerieService: GroupSerieService, private translocoService: TranslocoService, private locationService: LocationService, private errorService: ErrorService, private snackBar: MatSnackBar, private dialog: MatDialog) {
  }

  locationName(locationId: number): string {
    let locationSummaryDto = this.locationSummaryDtos.find((locationPreviewDto) => locationPreviewDto.locationId == locationId);
    return `${locationSummaryDto?.name} - ${locationSummaryDto?.city}, ${locationSummaryDto?.street}`;
  }

  ngOnInit(): void {
    this.locationService.getLocationSummaries().subscribe({
      next: (locationSummaryDtos: LocationSummaryDto[]) => {
        this.locationSummaryDtos = locationSummaryDtos;

        let defaultLocationId = locationSummaryDtos[0].locationId ?? 0;
        this.locationFormControl = new FormControl(defaultLocationId);

        this.loadGroupSeries(defaultLocationId);
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate("error.title.locations"));
      }
    });
  }

  loadGroupSeries(locationId: number): void {
    this.groupSerieService.getGroupSeries(locationId).subscribe({
      next: (groupSeriesDtos: GroupSeriesDto[]) => {
        this.groupSeriesDtos = groupSeriesDtos;
      },
      error: (error) => {
        this.errorService.handleError(error, this.translocoService.translate("error.title.group_series"));
      }
    });
  }

  changeLocation(event: any): void {
    let locationId: number = event.value;
    this.loadGroupSeries(locationId);
  }

  reorder(event: CdkDragDrop<string>): void {
    let groupSeriesDto: GroupSeriesDto = event.item.data;
    let previousIndex: number = event.previousIndex;
    let newIndex: number = event.currentIndex;

    if (previousIndex === newIndex) {
      return;
    }

    let previousGroupSeriesDto: GroupSeriesDto | null = newIndex === 0 ? null : this.groupSeriesDtos.filter((_, index) => index !== previousIndex)[newIndex - 1];

    let reorderDto: ReorderDto = { objectId: groupSeriesDto.groupSeriesId, previousObjectId: previousGroupSeriesDto?.groupSeriesId ?? null };

    let groupSeriesDtosCopy = [...this.groupSeriesDtos];
    const element = this.groupSeriesDtos.splice(previousIndex, 1)[0];
    this.groupSeriesDtos.splice(newIndex, 0, element);
    this.table.renderRows();

    this.groupSerieService.reorderGroupSeries(reorderDto).subscribe({
      next: () => {
        this.loadGroupSeries(this.locationFormControl.value);
      },
      error: (error) => {
        this.groupSeriesDtos = groupSeriesDtosCopy;
        this.errorService.handleError(error, this.translocoService.translate("error.title.reorder_group_series"));
      }
    });
  }

  edit(groupSeriesDto: GroupSeriesDto): void {
    this.dialog
      .open(ManageGroupSeriesDialog, {
        autoFocus: false,
        data: { groupSeriesDto: groupSeriesDto }
      })
      .afterClosed()
      .subscribe({
        next: (reload?: boolean) => {
          if (reload) {
            this.loadGroupSeries(this.locationFormControl.value);
          }
        }
      });
  }

  copyUrl(locationId: number, categoryGroup: string) {
    const url = `${environment.cenplexBookingWebUrl}/courses?customerId=${this.memoryService.customerId}&locationId=${locationId}&categoryGroup=${categoryGroup}`;

    navigator.clipboard.writeText(url).then(() => {
      this.snackBar.open(this.translocoService.translate("label.snackbar"), 'OK', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'bottom'
      });
    });
  }
}
